import * as WebAuthnJSON from '@github/webauthn-json'
import { Controller } from '@hotwired/stimulus'
// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'

// Connects to data-controller="webauthn-auth"
export default class extends Controller {
  static values = {
    challengeUrl: String,
    verificationUrl: String,
  }

  declare challengeUrlValue: string
  declare verificationUrlValue: string

  connect () {
    // TODO: use WebAuthnJSON.supported() to check if the browser supports WebAuthn, and handle the case where it
    // doesn't.
  }

  async auth () {
    try {
      const challengeResponse = await this.#request('post', this.challengeUrlValue)
      const credentialResponse = await WebAuthnJSON.get({ publicKey: challengeResponse })
      this.#onCompletion(await this.#verify(credentialResponse))
    } catch (error) {
      this.#onError(error)
    }
  }

  async #verify (credentialResponse: WebAuthnJSON.PublicKeyCredentialWithAssertionJSON): Promise<any> {
    return await this.#request('post', this.verificationUrlValue, {
      body: JSON.stringify({
        credential: credentialResponse,
      }),
      contentType: 'application/json',
      responseKind: 'json'
    })
  }

  #onCompletion (response: any): void {
    const url = response['redirect'] || '/'
    window.location.replace(url)
  }

  #onError (error: any): void {
    console.error('something is wrong', error)
  }

  async #request (method: string, url: string, options = {}): Promise<any> {
    const request = new FetchRequest(method, url, { redirect: 'error', responseKind: 'json', ...options })
    const response = await request.perform()
    return response.json
  }
}
